import { render, staticRenderFns } from "./SalesOrgImportItem.vue?vue&type=template&id=566bdffa&"
import script from "./SalesOrgImportItem.vue?vue&type=script&lang=ts&"
export * from "./SalesOrgImportItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports